const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];
const STORE = "pp_utm";

export const captureUtm = () => {
  const params = new URLSearchParams(window.location.search);
  const found = {};
  KEYS.forEach((k) => { const v = params.get(k); if (v) found[k] = v.slice(0, 200); });
  let ref = "";
  try { ref = document.referrer && new URL(document.referrer).host !== window.location.host ? document.referrer.slice(0, 300) : ""; } catch { ref = ""; }
  if (Object.keys(found).length || (ref && !sessionStorage.getItem(STORE))) {
    if (ref) found.referrer = ref;
    found.landing_page = window.location.pathname;
    sessionStorage.setItem(STORE, JSON.stringify(found));
  }
};

export const getUtm = () => {
  try { return JSON.parse(sessionStorage.getItem(STORE)) || {}; } catch { return {}; }
};
